import { Comment } from 'vue'

export const slotIsEmpty = slot => {
  return !slot || (slot && slot().findIndex(o => o.type !== Comment) === -1)
}

// TODO: re-use these funcitons in AppDeleteModal.vue

/**
 * 1. take all slots
 * 2. filter only those that start with the prefix. for example 'app-dialog:'
 * 3. collect them into an object, removing the prefix
 * 4. render slots from this object → add the prefix back → the slot list now contains only the slots we need for step 2
 *
 * @param {string} prefix - The slot name prefix to filter by (e.g., 'app-dialog:').
 * @returns {Object} An object mapping slot names (without prefix) to slot functions.
 */
export const getSlotsByPrefix = ({ slots, prefix }) => {
  const slotKeys = Object.keys(slots).filter(slot => slot.startsWith(prefix))
  return slotKeys.reduce((acc, slot) => {
    acc[removePrefix({ prefix, name: slot })] = slots[slot]
    return acc
  }, {})
}
export const prependPrefix = ({ prefix, name }) => `${prefix}${name}`
export const removePrefix = ({ prefix, name }) => {
  return name.replace(prefix, '')
}
